import React from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import CMSLayout from './CMSLayout';
import Video from './pages/Video';
import CreateVideo from './pages/CreateVideo';
import EditVideo from './pages/EditVideo';
import Category from './pages/Category';
import CreateCategory from './pages/CreateCategory';
import EditCategory from './pages/EditCategory';
import Playlist from './pages/Playlist';
import CreatePlaylist from './pages/CreatePlaylist';
import EditPlaylist from './pages/EditPlaylist';
import Tags from './pages/Tags';
import VideoThumbnailGenerator from './pages/VideoThumbnailGenerator';
import BulkUpload from './pages/BulkUpload';
import JobHistory from './pages/JobHistory';
import User from './pages/User';
import EditUser from './pages/EditUser';
import Payments from './pages/Payments';
import PaymentHistory from './pages/PaymentHistory';
import Refund from './pages/Refund';
import './Dashboard.css';

function Dashboard() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      <Sidebar onLogout={handleLogout} />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <h2>BabyBillion <span>Dashboard</span></h2>
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
        <div className="dashboard-main">
          <Routes>
            <Route path="/" element={<Navigate to="cms/video" replace />} />
            <Route path="cms" element={<CMSLayout />}>
              <Route index element={<Navigate to="video" replace />} />
              <Route path="video" element={<Video />} />
              <Route path="video/create" element={<CreateVideo />} />
              <Route path="video/:id/edit" element={<EditVideo />} />
              <Route path="category" element={<Category />} />
              <Route path="category/create" element={<CreateCategory />} />
              <Route path="category/:id/edit" element={<EditCategory />} />
              <Route path="playlist" element={<Playlist />} />
              <Route path="playlist/create" element={<CreatePlaylist />} />
              <Route path="playlist/:id/edit" element={<EditPlaylist />} />
              <Route path="tags" element={<Tags />} />
              <Route path="thumbnail-generator" element={<VideoThumbnailGenerator />} />
              <Route path="bulk-upload" element={<BulkUpload />} />
              <Route path="job-history" element={<JobHistory />} />
            </Route>
            <Route path="user" element={<User />} />
            <Route path="user/:userId/edit" element={<EditUser />} />
            <Route path="payments" element={<Payments />} />
            <Route path="payments/history" element={<PaymentHistory />} />
            <Route path="payments/refund" element={<Refund />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

